import { useState, useEffect } from "react";
import { MdVerified, MdLockPerson, MdVerifiedUser, MdArrowForward } from "react-icons/md";
import logolight from "../../assets/Netraa Logo Transparent.png"
import logodark from "../../assets/Netraa Logo Dark.png"
import logofooter from "../../assets/Apmosys Products Transparent logo.png"
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { FiSun, FiMoon } from "react-icons/fi";

export default function EnterpriseQuotePage() {
  const [darkMode, setDarkMode] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState();
  // Load theme from localStorage
  useEffect(() => {
    const theme = localStorage.getItem("theme") || "light";
    setDarkMode(theme === "dark");
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, []);

  const [formData, setFormData] = useState({
  fullName: "",
  workEmail: "",
  companyName: "",
  industry: "",
  jobTitle: "",
  mobileNumber: "",
  products: [],
  deployment: "",
  message: ""
});

const handleChange = (e) => {
  const { id, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [id]: value
  }));
};

const handleProductChange = (product) => {
  setFormData((prev) => {
    const exists = prev.products.includes(product);

    return {
      ...prev,
      products: exists
        ? prev.products.filter((p) => p !== product)
        : [...prev.products, product]
    };
  });
};

const handleDeploymentChange = (e) => {
  setFormData((prev) => ({
    ...prev,
    deployment: e.target.value
  }));
};

// const API_URL = process.env.REACT_APP_QUOTE_URL;

const submitQuote = async () => {
  try {
    const mobile = formData.mobileNumber.trim();
    const mobileRegex = /^\d{10}$/;

    if (!mobileRegex.test(mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    const body = { ...formData, mobileNumber: mobile };

    const res = await fetch("http://192.168.0.251:8000/api/request-quote", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    });

    if (res.ok) {
      setShowModal(true);
    } else {
      const errorData = await res.json().catch(() => null);
      console.error("Backend error:", errorData);
      alert("Failed to submit request.");
    }

  } catch (err) {
    console.error("Network error:", err);
    alert("Server error. Try again later.");
  }
};

  const toggleTheme = () => {
    setDarkMode((prev) => !prev);
    document.documentElement.classList.toggle("dark");
    localStorage.setItem("theme", darkMode ? "light" : "dark");
  };

  const back = () => {
    navigate(-1);
  };
  
  return (
    <div className="bg-background-light dark:bg-black text-text-main dark:text-white transition-colors duration-200 font-body min-h-screen flex flex-col">
      {/* Header */}
<header className="header bg-white dark:bg-[#141414] border-b border-gray-200 dark:border-gray-800 px-2 lg:px-6">
  <div className="flex items-center justify-between h-full">

    {/* LEFT: LOGO */}
    <div className="flex items-center gap-3 w-64">
      <div className="flex items-center justify-start -ml-4"> {/* Shift left */}
        <img
          src={logolight}
          alt="Netraa Docs Light"
          className="h-24 mt-3 w-auto dark:hidden"
        />
        <img
          src={logodark}
          alt="Netraa Docs Dark"
          className="h-24 mt-3 w-auto hidden dark:block"
        />
      </div>
    </div>

    {/* RIGHT: VERSION + THEME + PROFILE */}
<div className="flex items-center gap-6 w-64 justify-end">
  
  {/* Theme Toggle */}
  <button
    onClick={toggleTheme}
    aria-label="Toggle Dark Mode"
    className="relative flex items-center w-8 h-6 sm:w-12 sm:h-7 
               rounded-full bg-gray-300 dark:bg-orange-500 
               transition px-1 overflow-hidden"
  >
    {/* Knob */}
    <span
      className="w-4 h-4 sm:w-5 sm:h-5 bg-white rounded-full shadow-md 
                 transform transition-transform duration-300
                 flex items-center justify-center
                 translate-x-0 
                 dark:translate-x-2 sm:dark:translate-x-5"
    >
      <FiSun className="text-orange-500 text-[10px] sm:text-xs dark:hidden" />
      <FiMoon className="text-gray-700 text-[10px] sm:text-xs hidden dark:block" />
    </span>
  </button>

  {/* Back Button */}
<div className="relative group">
        <button
          onClick={back}
          className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition"
        >
          <ArrowLeftIcon className="w-6 h-6" />
        </button>

        <span className="absolute top-full left-1/2 -translate-x-1/2 mt-1
          px-2 py-1 text-xs rounded bg-gray-800 text-white
          opacity-0 group-hover:opacity-100 transition pointer-events-none whitespace-nowrap">
          Back
        </span>
      </div>

</div>
  </div>
</header>

{/* Main content: left info + right form scroll together */}
<main className="hide-scrollbar flex-1 overflow-auto">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full lg:grid lg:grid-cols-12 lg:gap-16 items-start py-12 lg:py-20">
    
    {/* Left Info */}
    <div className="hide-scrollbar lg:col-span-5 flex flex-col gap-10 mt-6 mb-12 lg:mb-0">
      <div className="flex flex-col gap-4">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 w-fit">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
          <span className="text-xs font-bold text-primary uppercase tracking-wider">Enterprise Plan</span>
        </div>
        <h1 className="text-4xl lg:text-5xl font-extrabold text-text-main dark:text-white leading-[1.15] tracking-tight">
          Let’s Build Your Enterprise Monitoring Strategy
        </h1>
        <p className="text-lg text-text-muted dark:text-gray-300 leading-relaxed max-w-lg">
          Get customized pricing tailored to your scale. Benefit from bulk licensing discounts and dedicated 24/7 engineering support designed for mission-critical systems.
        </p>
      </div>

      <div className="h-px w-full bg-gradient-to-r from-border-color to-transparent dark:from-white/10"></div>
      <h4 className="text-lg text-gray-500 dark:text-gray-400 leading-relaxed max-w-lg">
        Why Choose Netraa?
      </h4>

      <div className="flex flex-col gap-8">
        {[
          { icon: "Verified", title: "99.99% SLA Guarantee", desc: "Enterprise-grade uptime commitment with financial backing for peace of mind." },
          { icon: "public", title: "Global Follow-the-Sun Support", desc: "Dedicated engineering support teams available 24/7 across 3 continents." },
          { icon: "security", title: "Multi-cloud Security Compliance", desc: "SOC2 Type II & ISO 27001 certified security architecture ready for deployment." }
        ].map((feature, idx) => (
          <div key={idx} className="flex gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
              <span className="material-symbols-outlined text-2xl">{feature.icon}</span>
            </div>
            <div>
              <h4 className="text-lg font-bold text-text-main dark:text-white">{feature.title}</h4>
              <p className="text-sm text-text-muted dark:text-gray-400 mt-1">{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Right Quote Form */}
    <div className="hide-scrollbar lg:col-span-7">
      <div className="bg-card-light dark:bg-black rounded-lg shadow-soft border border-border-color dark:border-white/5 p-6 sm:p-8 lg:p-10 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-primary to-orange-300"></div>

        <div className="mb-8">
          <h2 className="text-2xl font-bold text-text-main dark:text-white">
            Request Enterprise Quote
          </h2>
          <p className="text-text-muted dark:text-gray-400 text-sm mt-1">
            Fill out the details below and our team will get back to you within 24 hours.
          </p>
        </div>

        <form className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  <InputField
    id="fullName"
    placeholder="Jane Doe"
    icon="person"
    label="Full Name"
    value={formData.fullName}
    onChange={handleChange}
  />

  <InputField
    id="workEmail"
    placeholder="jane@company.com"
    icon="mail"
    label="Work Email"
    type="email"
    value={formData.workEmail}
    onChange={handleChange}
  />
</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  <InputField
    id="companyName"
    placeholder="Acme Inc."
    icon="domain"
    label="Company Name"
    value={formData.companyName}
    onChange={handleChange}
  />

<div className="space-y-2">
              <label
                htmlFor="industry"
                className="text-sm font-semibold text-text-main dark:text-gray-200"
              >
                Industry
              </label>
              <select
  id="industry"
  value={formData.industry}
  onChange={handleChange}
  className="w-full p-4 rounded-lg border border-gray-300 dark:border-gray-600 
  bg-white dark:bg-black text-text-main dark:text-white 
  focus:ring-2 focus:ring-primary focus:border-primary"
>
                <option value="" disabled className="bg-white dark:bg-black text-black dark:text-white">
                  Select Industry
                </option>
                <option value="bfsi" className="bg-white dark:bg-black text-black dark:text-white">
                  BFSI
                </option>
                <option value="telecom" className="bg-white dark:bg-black text-black dark:text-white">
                  Telecom
                </option>
                <option value="ecommerce" className="bg-white dark:bg-black text-black dark:text-white">
                  E-commerce
                </option>
                <option value="healthcare" className="bg-white dark:bg-black text-black dark:text-white">
                  Healthcare
                </option>
                <option value="technology" className="bg-white dark:bg-black text-black dark:text-white">
                  Technology
                </option>
                <option value="manufacturing" className="bg-white dark:bg-black text-black dark:text-white">
                  Manufacturing
                </option>
              </select>
            </div>

</div>

          {/* INDUSTRY DROPDOWN - DARK MODE BLACK BG (FIXED) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
             <InputField
    id="jobTitle"
    placeholder="CTO"
    icon="badge"
    label="Job Title"
    value={formData.jobTitle}
    onChange={handleChange}
  />

  <InputField
  id="mobileNumber"
  placeholder="Mobile Number"
  icon="mobile"
  label="Mobile NO."
  value={formData.mobileNumber}
  onChange={handleChange}
/>
          </div>

          <CheckboxGroup
  label="Products of Interest"
  options={[
    "Netraa APM",
    "Netraa LH",
    "Netraa Orchestrator",
    "AI OPS Assistant"
  ]}
  selectedProducts={formData.products}
  onChange={handleProductChange}
/>

          <RadioGroup
  label="Deployment Preference"
  options={[
    { value: "saas", label: "SaaS Cloud" },
    { value: "selfhosted", label: "Self-Hosted / On-Prem" }
  ]}
  value={formData.deployment}
  onChange={handleDeploymentChange}
/>

          <div className="space-y-2 pt-2">
  <label
    htmlFor="message"
    className="text-sm font-semibold text-text-main dark:text-gray-200"
  >
    Message / Requirements
  </label>

  <textarea
    id="message"
    rows={4}
    value={formData.message}
    onChange={handleChange}
    placeholder="Tell us more..."
    className="w-full p-4 rounded-lg border 
    bg-white text-gray-900 border-gray-300 placeholder-gray-400
    dark:bg-black dark:text-gray-100 dark:border-gray-700 dark:placeholder-gray-500
    focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
</div>

          <div className="pt-4">
            <button
              type="button"
              onClick={submitQuote}
              className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold py-4 px-6 rounded-lg transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg shadow-orange-300"
            >
              <span>Request My Quote</span>
              <MdArrowForward className="text-xl" />
            </button>

            <p className="text-xs text-center text-text-muted mt-4">
              By submitting, you agree to our{" "}
              <a href="#" className="underline hover:text-primary">Terms of Service</a> and{" "}
              <a href="#" className="underline hover:text-primary">Privacy Policy</a>.
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</main>


      {/* Footer */}
      <footer className="bg-white dark:bg-card-dark border-t border-border-color dark:border-white/10 py-10 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col items-center md:items-start gap-1">
            <p className="text-xs font-bold text-text-muted uppercase tracking-wider">Powered by</p>
            <div className="flex items-center gap-3 w-64">
      <div className="flex items-center justify-start -ml-4"> {/* Shift left */}
        <img
          src={logofooter}
          alt="Apmosys logo"
          className="h-10 w-auto dark:hidden"
        />
        <img
          src={logofooter}
          alt="Apmosys logo"
          className="h-10 w-auto hidden dark:block"
        />
      </div>
    </div>

          </div>
          <div className="text-sm text-text-muted text-center">
            © 2026 ApMoSys Products Private Ltd. All rights reserved.
          </div>
          <div className="flex items-center gap-6 grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all">
            <div className="flex flex-col items-center gap-1 group cursor-pointer">
              <MdLockPerson className="text-3xl text-text-main dark:text-white" />
              <span className="text-[10px] font-bold text-text-main dark:text-white">SOC2 Type II</span>
            </div>
            <div className="w-px h-8 bg-border-color dark:bg-white/20"></div>
            <div className="flex flex-col items-center gap-1 group cursor-pointer">
              <MdVerified className="text-3xl text-text-main dark:text-white" />
              <span className="text-[10px] font-bold text-text-main dark:text-white">ISO 27001</span>
            </div>
          </div>
        </div>
      </footer>
      {showModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white dark:bg-gray-800 rounded-lg p-8 w-96 text-center shadow-lg relative">
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Thank You!</h3>
      <p className="text-gray-700 dark:text-gray-300 mb-6">
        Your request has been submitted. Our sales team will contact you soon.
      </p>
      <button
        onClick={() => setShowModal(false)}
        className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition"
      >
        Close
      </button>
    </div>
  </div>
)}
    </div>
  );
}

/* --- Subcomponents --- */
function InputField({ id, placeholder, label, icon, type = "text", value, onChange }) {
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="text-sm font-semibold text-text-main dark:text-gray-200">
        {label}
      </label>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
          <span className="material-symbols-outlined text-[20px]">{icon}</span>
        </div>

        <input
          type={type}
          id={id}
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full pl-10 pr-4 py-3 rounded-lg border-border-color bg-background-light dark:bg-background-dark/50 text-text-main dark:text-white focus:ring-2 focus:ring-primary focus:border-primary shadow-input transition-all outline-none"
        />
      </div>
    </div>
  );
}

export function SelectField({ id, label, options, defaultValue = "" }) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className="text-sm font-semibold">
        {label}
      </label>

      <select
        id={id}
        defaultValue={defaultValue}
        className="p-3 rounded-lg border border-border-color
                   bg-background-light dark:bg-background-dark/50
                   text-text-main dark:text-white outline-none"
      >
        {options.map((opt, idx) => (
          <option key={idx} value={opt.value} disabled={opt.disabled}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}


function CheckboxGroup({ label, options, selectedProducts, onChange }) {
  return (
    <div className="space-y-3 pt-2">
      <label className="text-sm font-semibold text-text-main dark:text-gray-200">{label}</label>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {options.map((opt, idx) => (
          <label key={idx} className="flex items-center space-x-3 p-3 border rounded-lg cursor-pointer">

            <input
              type="checkbox"
              checked={selectedProducts.includes(opt)}
              onChange={() => onChange(opt)}
            />

            <span className="text-sm">{opt}</span>

          </label>
        ))}
      </div>
    </div>
  );
}

function RadioGroup({ label, options, value, onChange }) {
  return (
    <div className="space-y-3 pt-2">
      <label className="text-sm font-semibold text-text-main dark:text-gray-200">{label}</label>

      <div className="flex gap-4">
        {options.map((opt, idx) => (
          <label key={idx} className="inline-flex items-center">

            <input
              type="radio"
              name="deployment"
              value={opt.value}
              checked={value === opt.value}
              onChange={onChange}
            />

            <span className="ml-2">{opt.label}</span>

          </label>
        ))}
      </div>
    </div>
  );
}